import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";
import GoogleSignIn from "../auth/GoogleSignIn";
// import AppleSignIn from "../auth/AppleSignIn"; // re‑enable later if needed

export default function Login() {
  const { setUser } = useAuth(); // 👈 hook into AuthContext
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/auth/login`,
        form
      );

      // ✅ backend returns { token }
      const { token } = res.data;

      // update AuthContext with email + token
      setUser({ email: form.email, token });

      // persist token for later requests (use "token" key to match CreatePoll.tsx)
      localStorage.setItem("token", token);

      setSuccess("Login successful!");
    } catch (err) {
      console.error("Login failed", err);
      setError("Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Welcome Back</h2>

      <form onSubmit={handleSubmit} className="auth-form">
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email"
          required
        />
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Password"
          required
        />
        <button type="submit">Login</button>
      </form>

      {error && <p className="error-msg">{error}</p>}
      {success && <p className="success-msg">{success}</p>}

      <div className="divider">or</div>

      <div className="social-buttons">
        <GoogleSignIn />
        {/* <AppleSignIn /> */}
      </div>
    </div>
  );
}
